import React from 'react'
import { Link } from 'react-router-dom'

import { HintToggleButton } from '@paytrace/pt-skel/Component'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { getSubmittedData } from '@paytrace/pt-skel/Helper'
import Event from '../Event'
import TransactionSearch from '../Component/TransactionSearch'
import { useMountUnmount } from '@paytrace/pt-skel/Hooks'

interface Props {}

const self = Symbol('DeleteStoreAndForward')
const HINT_SEARCH_TEXT = "Please provide the optional search criteria of the transaction(s) you wish to view. This text will be compared against each transaction's invoice number, billing name, shipping name, email address, customer ID, discretionary data and description."

export function DeleteStoreAndForward (props: Props) {
  useMountUnmount(() => {
    PubSub.sub(self, Event.SEARCH_TRANSACTIONS_RESPONSE, (json) => {
      // TODO: handle the response
    })

    return () => {
      PubSub.unsub(self)
    }
  })

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()

    PubSub.pub('VALIDATION_ERROR::clear')

    // TODO: properly map to the request
    const formData = getSubmittedData(e)
    PubSub.pub(
      Event.SEARCH_TRANSACTIONS_REQUEST,
      { ...formData }
    )

    return false
  }

  return (
    <>
      <div className='float-right'>
        <HintToggleButton />
        <a className='help-link' href="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2027258425/Store+Forward">Help</a>
      </div>
      <h1>Delete Store & Forward</h1>
      <hr className='clear' />

      <Link to='/storeforward.pay'>Back to Store & Forward</Link>

      <TransactionSearch onSubmit={submit} hintSearchText={HINT_SEARCH_TEXT}/>
    </>
  )
}

export default DeleteStoreAndForward
